import { render, staticRenderFns } from "./proposal-card.vue?vue&type=template&id=36eacc98&scoped=true&"
import script from "./proposal-card.vue?vue&type=script&lang=js&"
export * from "./proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./proposal-card.vue?vue&type=style&index=0&id=36eacc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eacc98",
  null
  
)

export default component.exports